<template>
  <div class="history-changes">
    <div class="history before">
      <div v-for="(item, index) in beforeChanges" :key="`before-${index}`">
        <span>{{ item.key }}: </span><span>{{ formatValue(item.value) }}</span>
      </div>
    </div>
    <div class="history after">
      <div v-for="(item, index) in afterChanges" :key="`after-${index}`">
        <span>{{ item.key }}: </span><span>{{ formatValue(item.value) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const KEYS_TO_IGNORE = ['id', 'created_at', 'updated_at', 'uuid']

export default {
  name: 'HistoryChanges',
  props: {
    changes: {
      type: Object,
    },
  },
  computed: {
    changesArray() {
      const changes = Object.entries(this.changes).filter(([key]) => !KEYS_TO_IGNORE.includes(key))
      return changes
    },
    beforeChanges() {
      return this.changesArray.map(([key, value]) => ({ key, value: value[0] }))
    },
    afterChanges() {
      return this.changesArray.map(([key, value]) => ({ key, value: value[1] }))
    },
  },
  methods: {
    formatValue(value) {
      if (value === true) return 'yes'
      if (value === false) return 'no'
      return value || '\u2013'
    },
  },
}
</script>

<style lang="scss">
.history-changes {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;

  .history {
    position: relative;
    padding: 0.75rem;
    padding-left: 5rem;
    display: flex;
    flex-direction: column;
    border-radius: var(--border-radius-m);
    border: 1px solid var(--form-control-border-color);

    &.after,
    &.before {
      span:first-of-type {
        color: #15141a;
        font-weight: 700;
      }
    }

    &.after {
      background-color: #dafbe1;
      border-color: rgba(74, 194, 107, 0.4);
    }

    &.before {
      background-color: var(--alert-danger-background-color);
      border-color: var(--alert-danger-border-color);
    }

    &.after::before,
    &.before::before {
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      bottom: 0;
      width: 4rem;
      border-radius: var(--border-radius-m) 0 0 var(--border-radius-m);
      font-weight: bold;
    }

    &.after::before {
      background-color: #aceebb;
    }

    &.before::before {
      background-color: #ffcecb;
    }

    &.after::after,
    &.before::after {
      position: absolute;
      left: 0;
      top: 50%;
      left: 2rem;
      transform: translate(-50%, -50%);
    }

    &.before::after {
      content: 'Before';
      color: var(--alert-danger-text-color);
    }

    &.after::after {
      content: 'After';
      color: #1a7f37;
    }
  }
}
</style>
